import React, { useEffect, useState } from 'react'
import { FaXmark } from 'react-icons/fa6';
import { saveSampleTrackingLog } from '../../service/SampleTrackingLogService';
import { saveTicket } from '../../service/TicketService';
import Notification from '../utility/Notification';

function SampleActivateSlideBar({activatingSample}) {

  const loggedUser = JSON.parse(
    atob(sessionStorage.getItem("x$sk72hyQwersgyhk"))
  );


  const [isOpenSlideBar, setIsOpenSlideBar] = useState(false);
  const [sample, setSample] = useState('');

  useEffect(() => {
    initialize()
    setApiResponse({})
    if(activatingSample){
      setSample(activatingSample)
      setIsOpenSlideBar(true);
      setTicketFormData((prev) => ({
        ...prev,
        ticketCode: activatingSample.data.sampleCode.replace('SMP','TKT'),
      }));
    }else{
      setSample('')
      setIsOpenSlideBar(false)     
    }   
    
  }, [activatingSample]);
  
  const [apiResponse, setApiResponse] = useState({
    //status: true, data: null, message: 'Already added : Fabric'
    status: "",
    message: "",
  });
  
   // Inputs
  const [ticketFormData, setTicketFormData] = useState({
    id: '',
    ticketCode: '',
    type: 0,
    sampleStatus:'',
    sampleSoldPrice:'',
    updatedAt: '',     
    errors: {},
  });

  
  const handleBasicInputChange = (e) => {
    const { name, value } = e.target;
    setTicketFormData((prevState) => ({ ...prevState, [name]: value }));    
  };

  // for Validation
  const [isValidTicketType, setIsValidTicketType] = useState(true);
  const [isValidSampleStatus, setIsValidSampleStatus] = useState(true);
  const [isValidSampleSoldPrice, setIsValidSampleSoldPrice] = useState(true);
  const [isValidUpdateAt, setIsValidUpdateAt] = useState(true);

  // change input validation state
  const setIsValidInputs = (isValid) => {
    setIsValidTicketType(isValid);
    setIsValidSampleStatus(isValid);
    setIsValidSampleSoldPrice(isValid); 
    setIsValidUpdateAt(isValid);   
  };

  // clear inputs
  const clearFormInputs = () => {
    setTicketFormData({
      id: '',
      ticketCode: '',
      type: 0,
      sampleStatus:'',
      sampleSoldPrice:'',
      updatedAt: '',     
      errors: {},
    });
  };

  // initialize inputs and state
  const initialize = () => {   
    clearFormInputs();    
    setIsValidInputs(true);   
  };

  const handleActivateButton = async (e) => {
    e.preventDefault();
    setIsValidInputs(true);

    if(ticketFormData.type === 'Regular'){

      let ticket = {
        id: ticketFormData.id,
        ticketCode: ticketFormData.ticketCode,
        type: ticketFormData.type,
        instalmentValue: sample.data.planValue.valueOfInstallment*sample.data.planValue.noOfInstallment,
        freeIssueInstalment: 6,
        status: 'PENDING',      

        sampleId: sample.data.id
      }; 

      let sampleTrackingLog = {
        id: '',
        sampleStatus: 'ACTIVE',
        remark: '',
        updatedAt: ticketFormData.updatedAt,
        endStatus: ticketFormData.sampleStatus,
        soldPrice: ticketFormData.sampleSoldPrice,
        sampleId: sample.data.id
      }
      
      let res = null;
      if(isValidRegularInputs()){
        res = await saveSampleTrackingLog(loggedUser.token,sampleTrackingLog)
        if(res != null){
          res = await saveTicket(loggedUser.token, ticket) 
          if(res != null){
            initialize()
            setIsOpenSlideBar(false)   
          }                
        }
      }else{
        setApiResponse({ status: false, message: "Invalid Inputs..." });
      }
    }

  }


  
  const isValidRegularInputs = () => {
    const errors = {};    

    if (ticketFormData.type === 0) {
      setIsValidTicketType(false);
      errors.type = "type is Required";     
    }

    if (!ticketFormData.updatedAt) {
      setIsValidUpdateAt(false);
      errors.updatedAt = "updatedAt is Required";     
    }
    
    if (!ticketFormData.sampleStatus) {
      setIsValidSampleStatus(false); 
      errors.sampleStatus = "sampleStatus is Required";     
    }

    if (ticketFormData.sampleStatus === 'Sold') {
      if(!ticketFormData.sampleSoldPrice || ticketFormData.sampleSoldPrice === '0'){
        setIsValidSampleSoldPrice(false)
        errors.sampleSoldPrice = "sampleSoldPrice is Required";     
      }
      
    }    

    setTicketFormData((prevState) => ({ ...prevState, errors }));
    
    // return true if there are no errors
    return Object.keys(errors).length === 0;
  };



  
  
  return (
    <div>
      { sample&&
        <div
          className={`absolute top-10 right-0 h-[93.5%] w-1/4 bg-white drop-shadow-[-4px_0_4px_rgba(0,0,0,0.1)] transition-transform duration-2000 ${
            isOpenSlideBar ? 'translate-x-0' : 'translate-x-full hidden'
          }`}                
        >  
          <div><button className="p-1" onClick={()=> setIsOpenSlideBar(false)}><FaXmark size={17} className="text-blue-700"/></button></div>
          <div className="px-2">
            <h2 className="font-semibold">
              <span className='pl-1'>Sample Activating :</span>
              <span className='pl-2 text-master_color-600'>{sample?sample.data.sampleCode:''}</span>             
            </h2>
            <hr className='border-slate-300 border-0.5'></hr>
            <div className="grid px-1">
              <div id='row-1'>
                <div className="text-master_color-300 text-base font-semibold drop-shadow-sm mt-2">Basic</div> 
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Ticket Code</div>
                  <div className="col-span-2">
                    <input
                      type="text"
                      name="ticketCode"
                      value={ticketFormData.ticketCode}
                      onChange={handleBasicInputChange}
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-sm font-semibold pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>  
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Ticket Type</div>
                  <div className="col-span-2">
                    <select
                      name="type"
                      value={ticketFormData.type}
                      onChange={handleBasicInputChange}                      
                      className={`w-full pl-1 py-0.5 text-sm outline-none bg-white border border-slate-400 focus:border-master_color-200 rounded`}                              
                    >
                      <option value="0" disabled={true}>-- select type --</option>
                      <option value="Regular">Regular</option>     
                      <option value="Mixed">Mixed</option>
                    </select> 
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Active Date</div>
                  <div className="col-span-2">
                    <input
                      type="date"
                      name="updatedAt"
                      value={ticketFormData.updatedAt}
                      onChange={handleBasicInputChange}                     
                      className={`w-full text-sm pl-2 py-1 bg-white outline-none border  focus:border-master_color-200 rounded
                            ${
                              isValidUpdateAt
                                ? "border-slate-400"
                                : "border-red-600"
                            }                        
                        `}
                    />
                  </div>
                </div>    
              </div>

              <div id='row-2-regular' className={`${['Mixed',0].includes(ticketFormData.type)?'hidden':''}`}>
                <div className="text-master_color-300 text-base font-semibold drop-shadow-sm mt-4">Regular Instalment Plan</div> 
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Plan</div>
                  <div className="col-span-2">
                    <input
                      type="text"                     
                      value={sample.data.planValue.plan.code}                     
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-sm font-semibold pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>  
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Inst. Value</div>
                  <div className="col-span-2">
                    <input
                      type="text"                     
                      value={'Rs '+sample.data.planValue.valueOfInstallment*sample.data.planValue.noOfInstallment}                     
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-sm pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Free Issue</div>
                  <div className="col-span-2">
                    <input
                      type="text"                     
                      value={6}                     
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-sm pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>    
              </div>

              <div id='row-2-mixed' className={`${['Regular',0].includes(ticketFormData.type)?'hidden':''}`}>
                <div className="text-master_color-300 text-base font-semibold drop-shadow-sm mt-4">Mixed Instalment Plan</div> 
                
                
              </div>

              <div id='row-3' className={`${[0].includes(ticketFormData.type)?'hidden':''}`}>
                <div className="text-master_color-300 text-base font-semibold drop-shadow-sm mt-4">Update Sample Status</div> 
                <div className="grid grid-cols-4 h-6 py-1">
                  <div className='text-end'>
                    <input
                      type='radio'
                      className='h-5 w-4 mt-1'
                      name='sampleStatus'
                      value={'Issued'}
                      onChange={handleBasicInputChange}
                    />
                  </div>
                  <div className='col-span-3 '>
                    <label className='ml-2 text-sm font-sans drop-shadow'>Issued to 1 <sup>st</sup> instalment</label>
                  </div>                                    
                </div>
                <div className="grid grid-cols-4 h-6 py-1">
                  <div className='text-end'>
                    <input
                      type='radio'
                      className='h-5 w-4 mt-1'
                      name='sampleStatus'
                      value={'Return'}
                      onChange={handleBasicInputChange}
                    />
                  </div>
                  <div className='col-span-3 '>
                    <label className='ml-2 text-sm font-sans drop-shadow'>Return to Store</label>
                  </div>                                    
                </div>
                <div className="grid grid-cols-4 h-6 py-1">
                  <div className='text-end'>
                    <input
                      type='radio'
                      className='h-5 w-4 mt-1'
                      name='sampleStatus'
                      value={'Sold'}
                      onChange={handleBasicInputChange}
                    />
                  </div>
                  <div className='col-span-3 '>
                    <label className='ml-2 text-sm font-sans drop-shadow'>Sold</label><br/>                    
                    <input
                      type="number"
                      name='sampleSoldPrice'                     
                      value={ticketFormData.sampleSoldPrice}                     
                      placeholder="Price"
                      onChange={handleBasicInputChange}                     
                      className={`w-36 text-sm font-semibold ml-2 pl-2 py-0.5 outline-none border
                               focus:border-master_color-200 rounded bg-white
                                  ${['','Issued','Return'].includes(ticketFormData.sampleStatus)?'hidden':''}
                                  ${
                                    isValidSampleSoldPrice
                                      ? "border-slate-400"
                                      : "border-red-600"
                                  }`}                        
                    />
                  </div>                                    
                </div>
               
                                           
              </div>
              
              <div id='row-4' className={`${[0].includes(ticketFormData.type)?'hidden':''} mt-8`}>                                
                <div className="grid grid-cols-1 py-1 px-[20%]">                  
                  <button
                    type="button"
                    onClick={handleActivateButton}
                    className="py-1.5 text-sm font-medium rounded text-white  items-center bg-master_color-400 hover:bg-master_color-200"
                  >                    
                    Activate
                  </button>
                </div>  
                <div className="grid grid-cols-1 py-1 px-[20%] items-center">
                  <span className="py-1.5 px-[20%] font-medium text-center">
                    <Notification response={apiResponse}/>
                  </span>                
                </div>                         
              </div>

              
              
            </div>           
          </div>
        </div>
      }
    </div>
  )
}

export default SampleActivateSlideBar